import React, { useEffect, useState } from "react";
import { dashboardApi } from "../../../api/DashboardApi";
import { ChannelContext } from "../../../context/channel";
import BaseToggle from "../../shared/BaseToggle";

import DesktopBannerImage from "../desktopBannerImage/DesktopBannerImage";
import MobileBannerImage from "../mobileBannerImage/MobileBannerImage";
import PageTitle from "../../shared/pageTitle/PageTitle";
import UploadBanner from "../../shared/UploadBanner";
import { BannerWrapper, Images, Text, Upload, UploadWrapper,  BodyContent } from "./style";

interface BannerProps {
  name: string;
  desktop_file: any;
  mobile_file: any;
  desktop_url: string;
  mobile_url: string;
  isActive: boolean;
  kind?: string;
  whitelabel_id?: number;
  desktop_name?: string;
  mobile_name?: string;
}

const BannerLoad = () => {
  const dashboardContext = React.useContext(ChannelContext);

  const [banners, setBanners] = useState<BannerProps[]>(
    dashboardContext.banners
  );

  useEffect(() => {}, [dashboardContext]);

  const [uploadedDesktopUrl, setUploadedDesktopUrl] = useState<string>(
    dashboardContext.bannerDesktopUrl
  );
  const [uploadedDesktopFile, setUploadedDesktopFile] = useState<File | any>(
    dashboardContext.bannerDesktopFile
  );
  const [uploadedMobileUrl, setUploadedMobileUrl] = useState<string>(
    dashboardContext.bannerMobileUrl
  );
  const [uploadedMobileFile, setUploadedMobileFile] = useState<File | any>(
    dashboardContext.bannerMobileFile
  );

  useEffect(() => {
    const files = [];

    for (const banner of banners) {
      if (banner.desktop_file) {
        files.push({
          field: `${banner.name}_desktop`,
          data: banner.desktop_file,
          name: banner.desktop_file.name,
        });
      }

      if (banner.mobile_file) {
        files.push({
          field: `${banner.name}_mobile`,
          data: banner.mobile_file,
          name: banner.mobile_file.name,
        });
      }
    }

    dashboardContext.setBannersFile(files);
    dashboardContext.setBanners(banners);
  }, [banners]);

  async function onDeleteBanner(index: number, type: string) {
    const currentBanner = banners[index];
    await dashboardApi.deleteBanner(
      `${currentBanner.name}_${type}` || "",
      dashboardContext.channel || ""
    );

    setBanners((prev) => {
      let newBanner = [...prev];
      newBanner[index] = {
        ...newBanner[index],
        [`${type}_file`]: "",
        [`${type}_url`]: "",
      };
      return newBanner;
    });

    dashboardContext.setBanners((prev: any) => {
      let newBanner = [...prev];
      newBanner[index] = {
        ...newBanner[index],
        [`${type}_file`]: "",
        [`${type}_url`]: "",
      };
      return newBanner;
    });
  }

  async function onToggleSwitch(checked: boolean, index: number) {
    if (checked) {
      setBanners((prev) => {
        const newBanners = [...prev];
        newBanners[index].isActive = checked;
        return newBanners;
      });
    } else {
      const currentBanner = banners[index];
      await dashboardApi.deleteBanner(
        `${currentBanner.name}_mobile` || "",
        dashboardContext.channel || ""
      );
      await dashboardApi.deleteBanner(
        `${currentBanner.name}_desktop` || "",
        dashboardContext.channel || ""
      );

      setBanners((prev) => {
        let newBanner = [...prev];
        newBanner[index] = {
          ...newBanner[index],
          desktop_file: "",
          desktop_url: "",
          desktop_name: "",
          mobile_file: "",
          mobile_url: "",
          mobile_name: "",
          isActive: checked,
        };
        return newBanner;
      });

      dashboardContext.setBanners((prev: any) => {
        let newBanner = [...prev];
        newBanner[index] = {
          ...newBanner[index],
          desktop_file: "",
          desktop_url: "",
          desktop_name: "",
          mobile_file: "",
          mobile_url: "",
          mobile_name: "",
          isActive: checked,
        };
        return newBanner;
      });
    }
  }

  return (
    <BodyContent>
      <PageTitle style={{ marginBottom: "80px" }}>Banners</PageTitle>
      {banners.map((banner, index) => (
        <div style={{ marginBottom: "48px" }} key={banner.name}>
          <BannerWrapper>
            <Text>Banner {index + 1}</Text>
            <BaseToggle
              index={index}
              initialCheck={index === 0 ? true : banner.isActive}
              onChange={onToggleSwitch}
              disabled={index === 0}
            />
          </BannerWrapper>
          {banner.isActive && (
            <UploadWrapper>
              <Upload>
                <UploadBanner
                  maxImageWidth={1440}
                  maxImageHeight={320}
                  fileImageUrl={uploadedDesktopUrl}
                  setBanner={setBanners}
                  inputId={"input-file-desktop1"}
                  idForUploadButton="input-upload-desktop"
                  isDesktop={true}
                  type={`desktop`}
                  index={index}
                  banner={banner}
                  onDeleteBanner={onDeleteBanner}
                />
              </Upload>

              <Upload>
                <UploadBanner
                  maxImageWidth={720}
                  maxImageHeight={360}
                  fileImageUrl={uploadedMobileUrl}
                  setBanner={setBanners}
                  inputId="input-file-mobile"
                  idForUploadButton="input-upload-mobile"
                  type={`mobile`}
                  index={index}
                  banner={banner}
                  onDeleteBanner={onDeleteBanner}
                />
              </Upload>
            </UploadWrapper>
          )}
        </div>
      ))}

      <Images>
        <DesktopBannerImage />
        <MobileBannerImage />
      </Images>
    </BodyContent>
  );
};

export default BannerLoad;
